import Thumb from '../Thumb/Thumb'
import './Galery.scss'
import Loader from '../Loader/Loader'
import { FetchData } from '../../Services/Service'

import { useState, useEffect, useMemo } from 'react'

export default function Galery({ periodSelected, paysOrigine, formationSelected, organismeSelected }) {
  const [data, setData] = useState([])
  const [isLoading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(64)

  const [searchTerm, setSearchTerm] = useState('');

  // Chargement des données
  useEffect(() => {
    FetchData()
      .then((bdd) => {
        setData(Array.isArray(bdd) ? bdd : [])
        setLoading(false)
      })
      .catch((err) => {
        console.error('Erreur FetchData:', err)
        setError(true)
        setLoading(false)
      })
  }, [])

  // Filtrage + tri
  const organismesFinal = useMemo(() => {
    let filtered = [...data];

    // Filtres existants (période, origine, etc.)
    if (periodSelected) filtered = filtered.filter(s => s.SOUS_ETAGE === periodSelected);
    if (paysOrigine) filtered = filtered.filter(s => s.ORIGINE === paysOrigine);
    if (formationSelected) filtered = filtered.filter(s => s.FORMATION === formationSelected);
    if (organismeSelected) filtered = filtered.filter(s => s.CATEGORIE === organismeSelected);

    // NOUVEAU : Recherche texte
    if (searchTerm.trim()) {
        const term = searchTerm.toLowerCase();
        filtered = filtered.filter(s => 
        s.ESPECE?.toLowerCase().includes(term) ||
        s.AUTEUR?.toLowerCase().includes(term) ||
        s.FORMATION?.toLowerCase().includes(term) ||
        s.ORIGINE?.toLowerCase().includes(term) ||
        s.REGION?.toLowerCase().includes(term) ||
        s.INFOS?.toLowerCase().includes(term) ||
        s.SPECIMEN?.toLowerCase().includes(term)
        );
    }

    return filtered.sort((a, b) => {
        // ton tri existant
        if (a.CATEGORIE < b.CATEGORIE) return -1;
        if (a.CATEGORIE > b.CATEGORIE) return 1;
        if (a.ESPECE < b.ESPECE) return -1;
        if (a.ESPECE > b.ESPECE) return 1;
        return 0;
    });
    }, [data, periodSelected, paysOrigine, formationSelected, organismeSelected, searchTerm]);

  // Pagination
  const totalItems = organismesFinal.length
  const totalPages = itemsPerPage === 'all' ? 1 : Math.ceil(totalItems / itemsPerPage)

  const paginatedData = useMemo(() => {
    if (itemsPerPage === 'all' || !itemsPerPage) return organismesFinal
    const start = (currentPage - 1) * itemsPerPage
    return organismesFinal.slice(start, start + itemsPerPage)
  }, [organismesFinal, currentPage, itemsPerPage])

  useEffect(() => {
    setCurrentPage(1)
  }, [totalItems, itemsPerPage])

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  if (isLoading) return <div id="galery"><Loader /></div>
  if (error) return <div id="galery"><div className="error">Erreur de chargement</div></div>

  return (
  <div id="galery">
    
    {/* === HAUT : Contrôles === */}
    <div className="galery-controls">
        {/* === BARRE DE RECHERCHE === */}
        {/* === BARRE DE RECHERCHE + COMPTEUR === */}
        <div className="search-container">
        <div className="search-bar">
            <input
            type="text"
            placeholder="Rechercher par espèce, auteur, formation, origine, région..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
            />
            <svg className="search-icon" viewBox="0 0 24 24">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            {searchTerm && (
            <button onClick={() => setSearchTerm('')} className="clear-search" title="Effacer la recherche">
                <svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
            </button>
            )}
        </div>

        {/* COMPTEUR DE RÉSULTATS (juste en dessous) */}
        {searchTerm && totalItems !== undefined && (
            <div className="search-results">
            {totalItems} résultat{totalItems > 1 ? 's' : ''} pour "<strong>{searchTerm}</strong>"
            </div>
        )}
        </div>

        <div className="items-per-page">
            <label htmlFor="items-per-page-select" className="label-visible">
                Afficher :
            </label>
            <select
                id="items-per-page-select"
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(e.target.value === 'all' ? 'all' : Number(e.target.value))}
                aria-label="Nombre d'éléments par page"
            >
                <option value={16}>16</option>
                <option value={32}>32</option>
                <option value={64}>64</option>
                <option value="all">Tous</option>
            </select>
            <span className="count" aria-live="polite">
                ({totalItems} spécimen{totalItems > 1 ? 's' : ''})
            </span>
        </div>

      {totalItems > 0 && itemsPerPage !== 'all' && (
        <div className="pagination-info">
          Page {currentPage} / {totalPages}
        </div>
      )}
    </div>

    {/* === CENTRE : Miniatures === */}
    <div className="thumbs-wrapper">
      {paginatedData.length > 0 ? (
        paginatedData.map((fiche) => (
          <Thumb
            key={fiche.SPECIMEN}
            ID={fiche.ID}
            SPECIMEN={fiche.SPECIMEN}
            ORIGINE={fiche.ORIGINE}
            REGION={fiche.REGION}
            FORMATION={fiche.FORMATION}
            ESPECE={fiche.ESPECE}
            AUTEUR={fiche.AUTEUR}
            DIMENSIONS={fiche.DIMENSIONS}
            ZONE={fiche.ZONE}
            INFOS={fiche.INFOS}
            SOUS_ETAGE={fiche.SOUS_ETAGE}
          />
        ))
      ) : (
        <p className="no-results">Aucun spécimen trouvé.</p>
      )}
    </div>

    {/* === BAS : Pagination === */}
    {totalPages > 1 && (
      <div className="pagination">
        {/* ... tout le code de pagination identique ... */}
        <button onClick={() => goToPage(1)} disabled={currentPage === 1}>
          <svg viewBox="0 0 24 24"><path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"/></svg>
        </button>
        <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
          <svg viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
        </button>

        {Array.from({ length: Math.min(totalPages, 7) }, (_, i) => {
          let pageNum
          if (totalPages <= 7) {
            pageNum = i + 1
          } else if (currentPage <= 4) {
            pageNum = i + 1
          } else if (currentPage >= totalPages - 3) {
            pageNum = totalPages - 6 + i
          } else {
            pageNum = currentPage - 3 + i
          }
          if (pageNum < 1 || pageNum > totalPages) return null
          return (
            <button
              key={pageNum}
              onClick={() => goToPage(pageNum)}
              className={currentPage === pageNum ? 'active' : ''}
            >
              {pageNum}
            </button>
          )
        })}

        <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
          <svg viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
        </button>
        <button onClick={() => goToPage(totalPages)} disabled={currentPage === totalPages}>
          <svg viewBox="0 0 24 24"><path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"/></svg>
        </button>
      </div>
    )}
  </div>
)
}